import { RootState } from "app/store";
import Menu from "components/common/Menu";
import MessagesContainer from "components/other/MessagesContainer";
import MessagesList from "components/other/MessagesList";
import { SideBarTabs } from "constants/tabs";
import { useTabActive } from "hook/useTabActive";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CommonStyles } from "styles/CommonStyles";
import { useLocation } from "react-router-dom";
import { setChat } from "reducers/chatReducer";
import PageHeader from "components/common/PageHeader";

function MessagesScreen() {
  const { chat } = useSelector((state: RootState) => state.chat);
  const dispatch = useDispatch();
  const location = useLocation();
  const conversationId = (location.state as { conversationId?: string } | null)
    ?.conversationId;

  const handleSelectChat = () => {};

  useTabActive(SideBarTabs.Messages.name);

  useEffect(() => {
    if (!conversationId) return;
    if (chat?._id === conversationId) return;

    dispatch(setChat({ _id: conversationId } as any));
  }, [chat?._id, conversationId, dispatch]);

  return (
    <div className={`${CommonStyles.pageWrapper} `}>
      <Menu />
      <PageHeader
        title="Messages"
        description="Open a conversation to reply to customers."
      />
      <div className={ClassName.container}>
        <div className={`${ClassName.content} ${chat && ClassName.mobileOnly}`}>
          <MessagesList onSelectChat={handleSelectChat} />
          <MessagesContainer />
        </div>
      </div>
    </div>
  );
}

export default MessagesScreen;

const ClassName = {
  container: "flex min-h-0 flex-1 items-stretch justify-center",
  content:
    "flex min-h-[calc(100vh-150px)] w-full overflow-hidden rounded-2xl border border-slate-200 bg-white p-3 sm:gap-6 sm:p-5",
  mobileOnly: "px-0 sm:px-6",
};
